module.exports = __webpack_public_path__ + "static/img/icon-67.67dc7ed9.svg";